export default __webpack_public_path__ + "static/media/union.e8930dcc.svg";